module.exports = __webpack_public_path__ + "static/media/portrait1.654733ae.jpg";